import HealthFilter from "./HealthFilter"

export default  HealthFilter;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/HealthsFilter/HealthFilter/index.js